import React, { useState, useEffect } from 'react'
import {
    Button,
    Typography,
    ClickAwayListener,
    Tooltip,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { makeStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import { activeDeleteProposalImgProfile } from "../../../../store/actions/DeleteImageAction";
import './ProposalLawyer.scss';

const maleFirebase = process.env.REACT_APP_AVATAR_MALE;
const femaleFirebase = process.env.REACT_APP_AVATAR_FEMALE;
const lawFirmFirebase = process.env.REACT_APP_AVATAR_LAWFIRM;

const useStyles = makeStyles({
    buttonImage: {
        color: '#013957',
        border: '1px solid #013957',
        borderRadius: 20,
        width: 160,
        height: 40,
        '&:hover': {
          color: 'white',
          backgroundColor: '#35b9b6',
          border: 'none',
        },
        '@media(max-width: 768px)': {
          width: 152,
        },
    },
    buttonName: {
        fontSize: 16,
        fontWeight: 'bold',
        textTransform: 'initial',
        lineHeight: 'normal',
    },
    inputFile: {
        display: 'none',
    },
    customTooltip: {
        backgroundColor: '#094565',
        margin: '4px 0 0',
        padding: 8,
        maxWidth: 216,
        width: 206,
        lineHeight: 1.2,
      },
      tooltipParagraph: {
        margin: 0,
        fontSize: 14,
        '& b': {
          fontSize: 14,
          fontWeight: 'bold',
        },
      },
});

const AvatarPhoto = props => {

    const {
        name,
        role,
        genero,

        setFieldValue,
        deleteImg,
        flagEdit,
        value,
        cancelData,
        setCancelData,
        newProposalData,
        selectedProposal,
        activeDeleteProposalImgProfile,
    } = props

    const editFlag = selectedProposal &&  Object.values(selectedProposal).length > 0 ? true : false;
    const createFlag = newProposalData &&  Object.values(newProposalData).length > 0 ? true : false;
    const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
    const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
    const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';
    const defaultAvatar =
        role === 'lawyer'
        ? genero === 'male'
            ? maleAvatar
            : femaleAvatar
        : lawFirmAvatar;


    const classes = useStyles()
    const [dataPhoto, setDataPhoto] = useState('')
    const [openTooltipImgProfile, setOpenTooltipImgProfile] = useState(false);
    // console.log('selectedProposal', selectedProposal);
    // console.log('newProposalData', newProposalData);
    // console.log('Object.values(selectedProposal)', Object.values(selectedProposal));
    // console.log('Object.values(newProposalData)', Object.values(newProposalData));

    

    (function keepFirebasedInLocal() {
        if (
            (selectedProposal && selectedProposal.urlImgLogo && selectedProposal.urlImgLogo === value) ||
            (newProposalData && newProposalData.urlImgLogo && newProposalData.urlImgLogo === value)
        ) {
            localStorage.setItem('proposalUrlImage', value)
        } else if (
            (editFlag && selectedProposal && selectedProposal.urlImgLogo &&
                (selectedProposal.urlImgLogo === maleFirebase ||
                selectedProposal.urlImgLogo === femaleFirebase ||
                selectedProposal.urlImgLogo === lawFirmFirebase)) ||
            (createFlag && newProposalData.urlImgLogo &&
                (newProposalData.urlImgLogo === maleFirebase ||
                newProposalData.urlImgLogo === femaleFirebase ||
                newProposalData.urlImgLogo === lawFirmFirebase)
            )
        ) {
            localStorage.setItem(
                'proposalUrlImage',
                selectedProposal.urlImgLogo ?
                selectedProposal.urlImgLogo :
                newProposalData.urlImgLogo
            )
        } else if (
            value &&
            typeof value === 'string' &&
            value.includes('firebase')
        ) {
            localStorage.setItem('proposalUrlImage', value)
        }
    })()

    useEffect(() => {
        // TO EDIT
        const local = localStorage.getItem('proposalUrlImage')
        if (
            local &&
            local.includes('firebase') &&
            !deleteImg.proposalImgProfile &&
            value &&
            typeof value !== 'object'
        ) {
            setDataPhoto(local)
        } else if (deleteImg.proposalImgProfile) {
            setDataPhoto('')
        }
        // TO ADD
        if (cancelData) {
            setDataPhoto('')
            if (!dataPhoto) {
                setCancelData(false)
            }
        }
    }, [
        cancelData,
        dataPhoto,
        deleteImg.proposalImgProfile,
        flagEdit,
        setCancelData,
        value
    ])

    const handleTooltipImgProfileClose = () => {
        setOpenTooltipImgProfile(false);
    };

    const handleTooltipImgProfileOpen = () => {
        setOpenTooltipImgProfile(true);
    };

    const handleChangeEditAvatar = e => {
        let file = e.target.files[0], reader = new FileReader();
        reader.readAsDataURL(file);
        setFieldValue(name, file);
        reader.onload = (r) => {
            setDataPhoto(r.target.result)
        }
        activeDeleteProposalImgProfile(false)
    };

    const clickDeleteImage = () => {
        activeDeleteProposalImgProfile(true)
        setDataPhoto("")
        setFieldValue(name, "")
    }

    return (
        <>
            <div className="addHolders_fotoUser">
                <figure className="addHolders_container-image">
                    <img
                        id="target"
                        src={
                            dataPhoto ?
                            dataPhoto :
                            defaultAvatar
                        }
                        alt="imgProfile"
                    />
                    {(
                        !dataPhoto ||
                        (
                            dataPhoto &&
                            (dataPhoto === lawFirmFirebase ||
                            dataPhoto === maleFirebase ||
                            dataPhoto === femaleFirebase)
                        )
                    ) ? (
                        ''

                    ) : (
                        <div className="addHolders_container-trash">
                        <img
                            src="/img/profile/trash.svg"
                            onClick={clickDeleteImage}
                            alt="borrar"
                        />
                        </div>
                    )}
                </figure> 
                <div
                    style={{
                        paddingLeft: 24,
                        display: 'flex',
                        flexFlow: 'column',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ display: 'flex' }}>
                    <div className="addHolders_item2">
                        <span id="t1_addHolders">Imagen de logotipo</span>

                        <div
                        className="addHolders_item2_size"
                        >
                        <p id="t2_addHolders">
                            (Tamaño máximo 100 KB. JPG, PNG.) &nbsp;&nbsp;
                        </p>

                        {isMobile === true ?
                            <ClickAwayListener onClickAway={handleTooltipImgProfileClose}>
                            <Tooltip
                                onClose={handleTooltipImgProfileClose}
                                open={openTooltipImgProfile}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                classes={{ tooltip: classes.customTooltip }}
                                title={
                                    <p className={classes.tooltipParagraph}>
                                        El <b>peso</b> de la foto <b>no</b> debe ser <b>mayor a 4MB</b> y debe tener un tamaño mínimo de 176x176px.
                                    </p>
                                }
                                placement='left'
                            >
                                <img
                                    src="/img/profile/ayuda.png"
                                    alt="?"
                                    onClick={handleTooltipImgProfileOpen}
                                />
                            </Tooltip>
                            </ClickAwayListener> :
                            <Tooltip
                                classes={{ tooltip: classes.customTooltip }}
                                title={
                                    <p className={classes.tooltipParagraph}>
                                        El <b>peso</b> de la foto <b>no</b> debe ser <b>mayor a 4MB</b> y debe tener un tamaño mínimo de 176x176px.
                                    </p>
                                }
                                placement='bottom'
                            >
                                <img src="/img/profile/ayuda.png" alt="?" />
                            </Tooltip>
                        }
                        </div>
                    </div>
                    </div>

                    <div className="addHolders_horizontal-layout addHolders_item5">
                        <input
                            type="file"
                            onChange={handleChangeEditAvatar}
                            className={classes.inputFile}
                            id={name}
                            name={name}
                            accept=".jpg, .jpeg, .png"
                        />
                        <label htmlFor={name}>
                            <Button
                                variant="outlined"
                                className={classes.buttonImage}
                                component="span"
                            >
                                <Typography className={classes.buttonName}>
                                    Seleccionar foto
                                </Typography>
                            </Button>
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    uid: state.authClient.uid,
    deleteImg: state.DeleteImageReducer.deleteImg,
    role: state.authClient.role,
    genero: state.authClient.genero,
    selectedProposal: state.proposalsReducer.selectedProposal,
    newProposalData: state.proposalsReducer.newProposalData,

});

const mapDispatchToProps = dispatch => ({
    activeDeleteProposalImgProfile: (boolCancel) =>
        dispatch(activeDeleteProposalImgProfile(boolCancel)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AvatarPhoto);
